import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './AdminWorkListScreen';
import AdminWorkList from './AdminWorkListScreen';
import { StoreState } from 'src/store/reducers';
import { getAdminWorks } from '../../../../../../../../store/actions/adminWork-actions';
import { QueryParams } from '../../../../../../../../types/grid';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.adminWorks.data,
        inProgress: state.adminWorks.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getAdminWorks(params)),
    };
}

const AdminWorkListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(AdminWorkList);

export default AdminWorkListScreen;
